import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const NODE_EPOCH_OFFSET = 124 * 3600 + 7 * 60 + 41;

const formatUptime = (total) => {
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

export const Nav = ({ onRequestAccess }) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setTick((v) => v + 1), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-zinc-800 bg-black/80 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3 text-white hover:text-zinc-300 transition-colors duration-300"
        >
          <img
            src="/logo-emblem.png"
            alt="Equinox emblem"
            className="h-8 w-8 object-contain"
          />
          <span className="font-display tracking-tight text-[11px] sm:text-xs uppercase" style={{ fontWeight: 800 }}>
            Equinox Infrastructure Holdings, LLC
          </span>
        </a>
        <div className="flex items-center gap-6">
          <div
            data-testid="header-status-indicator"
            className="hidden sm:flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-zinc-400"
          >
            <span className="status-dot inline-block w-1.5 h-1.5 rounded-full bg-green-500" />
            Secure System Node: Active
            <span data-testid="header-uptime-ticker" className="text-zinc-600 tabular-nums">
              · Uptime {formatUptime(NODE_EPOCH_OFFSET + tick)}
            </span>
          </div>
          <button
            data-testid="header-data-room-btn"
            onClick={onRequestAccess}
            className="text-[10px] tracking-[0.2em] uppercase border border-zinc-700 px-4 py-2 text-white hover:bg-white hover:text-black transition-colors duration-300"
          >
            Data Room
          </button>
        </div>
      </div>
    </motion.header>
  );
};
